import styled from 'styled-components'

export const StyledPagination = styled.div`
  padding: 1rem 0;
  background-color: white;
  transform: rotateX(90deg);

  ul {
    width: 100%;
    display: flex;
    justify-content: center;
    gap: 1rem;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    cursor: pointer;

    &.selected {
      color: red;
    }
  }
`
